import { switchOrderNumberRegEx } from "./general.utils";

export const historiesFetching = (history) => {
  const result = {
    ...history,
    isFetching: true
  };
  return result;
};

export const historiesData = (history, data) => {
  const result = {
    ...history,
    histories: data,
    isFetching: false,
    currentPage: data.currentPage ? data.currentPage : 1,
    totalPage: data.totalPage ? data.totalPage : 1
  };
  return result;
};

export const historiesError = (history, error) => {
  const result = {
    ...history,
    errorMessage: error,
    isFetching: false
  };
  return result;
};

export const historiesChangePage = (history, newPage) => {
  const result = {
    ...history,
    currentPage: history.currentPage !== newPage ? newPage : history.currentPage
  };
  return result;
};

export const portfoliosFetching = (portfolio) => {
  const result = {
    ...portfolio,
    isFetching: true
  };
  return result;
};

export const portfoliosData = (portfolio, data) => {
  const result = {
    ...portfolio,
    portfolios: data,
    isFetching: false
  };
  return result;
};

export const portfoliosError = (portfolio, error) => {
  const result = {
    ...portfolio,
    errorMessage: error,
    isFetching: false,
    portfolios: []
  };
  return result;
};

export const changeCurrentGroupType = (state, currentGroupType) => {
  const result = {
    ...state,
    currentGroupType: currentGroupType ? currentGroupType : '0'
  }
  return result;
}

export const dividendsData = (dividend, data) => {
  const result = {
    ...dividend,
    dividends: data,
    isFetching: false
  };
  return result;
};

export const dividendsError = (dividend, error) => {
  const result = {
    ...dividend,
    errorMessage: error,
    isFetching: false
  };
  return result;
};

export const setInitialAccountNumber = (accounts) => {
  let result = [];
  result.push(accounts.accounts[0].accountNumber);
  return result;
};

export const filterAccountNumber = (state, accounts) => {
  let result = {
    ...state,
    accountNumbers: accounts ? accounts : []
  };

  return result;
};

export const getFundListFromData = (state, data) => {
  let fundList = data 
    ? data.map(x => x.funds.reduce((prev, curr) => 
      prev.includes(curr.fundCode)
      ? prev 
      : [...prev, curr.fundCode], [])).flat().map(item => {
        return { 
          name: item,
          value: item.toUpperCase(),
          type: 'fundCode'
        };
      }) 
    : [];
  return {
    ...state,
    fundList: fundList
  };
};

export const filterMonthlyReturn = (dataList) => {
  var monthList = [];
  
  if (dataList.length > 0) {
    dataList.forEach((years) => {
      let data = [];
      for (let i = 0; i < 12; i++) {
        if (years.items.length > 0) {
          let dataMonth = years.items.find(item => item.month === i + 1);
          if (dataMonth) { 
            data.push({ month: i+1, value: dataMonth.value });
          } else {
            data.push({ month: i+1, value: null });
          } 
        } else {
          data.push({ month: i+1, value: null });
        }
      }

      monthList.push({
        year: years.year,
        items: data,
        total: years.yearlyReturn ? years.yearlyReturn : null
      });
    });
  }

  return monthList;
};

export const transformOrderData = (orders) => {
  const cloneOrders = orders.slice();

  let result= [];
  cloneOrders.forEach((order) => {
    if (switchOrderNumberRegEx.test(order.number)) {
      if (order.tradeType === 'S') {
        const toFund = cloneOrders.find(x => switchOrderNumberRegEx.test(x.number) && x.tradeType === 'B' && x.number.slice(0, -1) === order.number.slice(0, -1));
        result.push({...order, toFund});
      } else if (order.tradeType === 'B') {
        const fromFund = cloneOrders.find(x => switchOrderNumberRegEx.test(x.number) && x.tradeType === 'S' && x.number.slice(0, -1) === order.number.slice(0, -1));
        delete order['toFund'];
        result.push({...order, fromFund});
      }
    } else {
      if (order.tradeType !== 'W') {
        delete order['toFund'];
      }
      result.push(order);
    }
  })
  
  return result;
}

export const duplicateNumber = (data) => {
  const cloneData = [...data];

  return cloneData.map((item) => {
    return {
      ...item,
      number: item.orderNumber
    }
  })
}